export default __webpack_public_path__ + "static/media/October2013.17530b66.png";